import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

const API_URL = 'http://vtym-douane.test/backend/wp-json';

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Vérifier si l'utilisateur est connecté au chargement
    useEffect(() => {
        const token = localStorage.getItem('vtym_token');
        const userData = localStorage.getItem('vtym_user');
        
        if (token && userData) {
            setUser(JSON.parse(userData));
        }
        
        setLoading(false);
    }, []);

    // Login
    const login = async (email, password) => {
        try {
            const response = await fetch(`${API_URL}/douane/v1/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password })
            });

            const data = await response.json();

            if (data.success) {
                // Sauvegarder le token et les infos utilisateur
                localStorage.setItem('vtym_token', data.token);
                localStorage.setItem('vtym_user', JSON.stringify(data.user));
                setUser(data.user);
                return { success: true };
            } else {
                return { success: false, message: data.message || 'Identifiants incorrects' };
            }
        } catch (error) {
            console.error('Erreur login:', error);
            return { success: false, message: 'Erreur de connexion au serveur' };
        }
    };

    // Register (optionnel - si l'utilisateur veut créer un compte manuellement)
    const register = async (userData) => {
        try {
            const response = await fetch(`${API_URL}/douane/v1/auth/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData)
            });

            const data = await response.json();

            if (data.success) {
                // Auto-login après inscription
                localStorage.setItem('vtym_token', data.token);
                localStorage.setItem('vtym_user', JSON.stringify(data.user));
                setUser(data.user);
                return { success: true };
            } else {
                return { success: false, message: data.message || 'Erreur lors de l\'inscription' };
            }
        } catch (error) {
            console.error('Erreur register:', error);
            return { success: false, message: 'Erreur de connexion au serveur' };
        }
    };

    // Logout
    const logout = () => {
        localStorage.removeItem('vtym_token');
        localStorage.removeItem('vtym_user');
        setUser(null);
    };

    // Récupérer le token
    const getToken = () => {
        return localStorage.getItem('vtym_token');
    };

    const value = {
        user,
        loading,
        login,
        register,
        logout,
        getToken,
        isAuthenticated: !!user
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

// Hook personnalisé pour utiliser le contexte
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth doit être utilisé à l\'intérieur de AuthProvider');
    }
    return context;
};

export default AuthContext;